import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// devextreme imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSelectBoxModule,
    DxTabsModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxNumberBoxModule,
    DxSwitchModule,
    DxMenuModule,
    DxFileUploaderModule,
    DxValidatorModule
} from 'devextreme-angular';

// Module imports
import { ManagementCommonModule } from '../management-common/management-common.module';
import { SharedModule } from '../shared-module/shared.module';
import { SharedWorkflowModule } from '../shared-workflow-module/shared-workflow.module';
import { WorkflowModule } from '../workflow/workflow.module';

// Component imports
import { BoardApprovalEditorComponent } from './component/board-approval-editor/board-approval-editor.component';
import { BoardApprovalNoteEditorComponent } from './component/board-approval-note-editor/board-approval-note-editor.component';
import { CollectionReferralDetailComponent } from './component/collection-referral-detail/collection-referral-detail.component';
import { CollectionsAttachmentSelectorComponent } from './component/collections-attachment-selector/collections-attachment-selector.component';
import { ArchitectualApplicationEditorModule } from './component/architectural-application-editor/architectural-application-editor.module';
import { ArchitecturalApplicationViewerComponent } from './component/architectural-application-viewer/architectural-application-viewer.component';

@NgModule({
    declarations: [
        BoardApprovalEditorComponent,
        BoardApprovalNoteEditorComponent,
        CollectionReferralDetailComponent,
        CollectionsAttachmentSelectorComponent,
        ArchitecturalApplicationViewerComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        DxLoadPanelModule,
        DxBoxModule,
        DxToolbarModule,
        DxTabsModule,
        DxRadioGroupModule,
        DxDateBoxModule,
        DxFormModule,
        DxDataGridModule,
        DxButtonModule,
        DxDropDownButtonModule,
        DxPopupModule,
        DxTextAreaModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxSwitchModule,
        DxMenuModule,
        DxFileUploaderModule,
        DxValidatorModule,
        SharedModule,
        ManagementCommonModule,
        SharedWorkflowModule,
        ArchitectualApplicationEditorModule,
        WorkflowModule
    ],
    exports: [
        ArchitectualApplicationEditorModule,
        BoardApprovalEditorComponent,
        BoardApprovalNoteEditorComponent,
        CollectionReferralDetailComponent,
        CollectionsAttachmentSelectorComponent,
        ArchitecturalApplicationViewerComponent
    ]
})
export class SharedACCBoardApprovalModule {}
